export enum QuizStatus {
  SETUP_IN_PROGRESS = 'SETUP_IN_PROGRESS',
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED'
}
